<template>
  <aside class="alert-triage">
    <div class="alert-triage__header">
      <h3 class="alert-triage__title">Your alert triage</h3>
      <nuxt-link to="/profile/my-watchlist" class="alert-triage__personalise">
        Personalise your alerts
      </nuxt-link>
    </div>
    <p class="alert-triage__subtitle">Updates for you to review</p>
    <div class="alert-triage__list">
      <div
        v-for="(alert, index) in alerts"
        :key="index"
        class="triage-card"
      >
        <h4 class="triage-card__title">{{ alert.title }}</h4>
        <div class="triage-card__row">
          <div class="triage-card__indicators">
            <span
              class="triage-card__badge"
              :class="`triage-card__badge--${alert.classification}`"
            >
              {{ formatClassification(alert.classification) }}
            </span>
            <span class="triage-card__score">p {{ alert.priority }}</span>
            <span class="triage-card__score">r {{ alert.recency }}</span>
          </div>
          <div class="triage-card__actions">
            <button class="triage-card__btn triage-card__btn--dismiss" @click="$emit('dismiss', index)">
              Dismiss
            </button>
            <button class="triage-card__btn triage-card__btn--action" @click="$emit('action', index)">
              Action
            </button>
          </div>
        </div>
      </div>
      <div v-if="!alerts.length" class="alert-triage__empty">
        No alerts to review.
      </div>
    </div>
    <nuxt-link v-if="alerts.length" to="/regulatory_updates" class="alert-triage__see-all">
      See all alerts
      <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </nuxt-link>
  </aside>
</template>

<script>
export default {
  name: "AlertTriage",
  data() {
    return {
      alerts: [
        {
          title: "Draft law increasing gambling taxation resubmitted to the Bulgarian parliament",
          classification: "indicative",
          priority: 64,
          recency: 30,
        },
        {
          title: "Finnish government announces licensing fees under new gambling framework",
          classification: "actionable",
          priority: 64,
          recency: 30,
        },
        {
          title: "New Zealand company and director plead guilty to illegal multi-million dollar online lottery",
          classification: "informative",
          priority: 64,
          recency: 30,
        },
        {
          title: "Draft law increasing gambling taxation resubmitted to the Bulgarian parliament",
          classification: "indicative",
          priority: 64,
          recency: 30,
        },
        {
          title: "Finnish government announces licensing fees under new gambling framework",
          classification: "actionable",
          priority: 64,
          recency: 30,
        },
      ],
    };
  },
  methods: {
    formatClassification(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.alert-triage {
  background: $white;
  border: 1px solid #ecedf0;
  border-radius: 8px;
  padding: 20px;

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 2px;
  }

  &__title {
    font-size: 1.7rem;
    font-weight: 700;
    color: $text;
    margin: 0;
    line-height: 1.3;
  }

  &__personalise {
    font-size: 1.1rem;
    color: $accentBlue;
    text-decoration: none;
    white-space: nowrap;
    font-weight: 600;
    flex-shrink: 0;
    padding-top: 2px;

    &:hover {
      text-decoration: underline;
    }
  }

  &__subtitle {
    font-size: 1.2rem;
    color: $light_gray;
    margin: 0 0 16px;
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__empty {
    padding: 24px 0;
    text-align: center;
    color: $light_gray;
    font-size: 1.3rem;
  }

  &__see-all {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 12px;
    font-size: 1.25rem;
    font-weight: 600;
    color: $accentBlue;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.triage-card {
  padding: 14px 0;
  border-bottom: 1px solid #ecedf0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
  }

  &__title {
    font-size: 1.3rem;
    font-weight: 600;
    color: $text;
    line-height: 1.4;
    margin: 0 0 8px;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: wrap;
  }

  &__indicators {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__badge {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 3px;
    font-size: 1.05rem;
    font-weight: 700;

    &--indicative {
      background: rgba($indicative, 0.12);
      color: darken($indicative, 10%);
    }

    &--actionable {
      background: rgba($actionable, 0.1);
      color: darken($actionable, 5%);
    }

    &--informative {
      background: rgba($informative, 0.1);
      color: darken($informative, 5%);
    }
  }

  &__score {
    display: inline-flex;
    align-items: center;
    padding: 1px 6px;
    border: 1px solid #ecedf0;
    border-radius: 3px;
    font-size: 1.05rem;
    color: $light_gray;
    font-weight: 600;
  }

  &__actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
  }

  &__btn {
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 1.15rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease;
    border: 1px solid;
    line-height: 1.4;

    &--dismiss {
      background: $white;
      border-color: #dcdfe6;
      color: $light_gray;

      &:hover {
        background: #f5f6f8;
        color: $text;
      }
    }

    &--action {
      background: $corporateBlue;
      border-color: $corporateBlue;
      color: $white;

      &:hover {
        background: lighten($corporateBlue, 6%);
      }
    }
  }
}
</style>
